import React, { useEffect, useState, useRef } from "react"
import { Container, Button, Form } from "react-bootstrap"
import { db } from "./../firebase"
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  updateDoc,
} from "firebase/firestore"
import { getFunctions, httpsCallable } from "firebase/functions"
import Navigation from "./Navigation"
import { useAuth } from "../contexts/AuthContext"

export default function Admin() {
  const [becarios, setBecarios] = useState([])
  const [loading, setLoading] = useState(false)
  const emailRef = useRef()
  const functions = getFunctions()

  const { currentAdmin } = useAuth()

  //===================================
  // Get documents
  //===================================

  // Query only paid documents
  const listaBecarios = query(
    collection(db, "users"),
    where("becario", "==", true)
  )

  // Hook for unpaid users
  useEffect(() => {
    const unsubBecarios = onSnapshot(listaBecarios, (snapshot) =>
      setBecarios(snapshot.docs.map((doc) => doc.data()))
    )
    return () => unsubBecarios()
  }, [])

  //===================================
  // Functions
  //===================================

  const addBecarioRole = httpsCallable(functions, "addBecarioRole")
  const removeBecarioRole = httpsCallable(functions, "removeBecarioRole")

  const getUID = httpsCallable(functions, "getUID")

  const updateBecario = async (uid, value) => {
    setLoading(true)
    try {
      const docRef = doc(db, "users", uid)

      await updateDoc(docRef, "becario", value)
    } catch (error) {}

    setLoading(false)
  }

  // function fetchData() {

  // setLoading(true)

  //   onSnapshot(currentData, (querySnapshot) =>  {

  //   const records = [];

  //   querySnapshot.forEach((doc) => {
  //     // doc.data() is never undefined for query doc snapshots
  //     // console.log(doc.id, " => ", doc.data());
  //     // setUsers([...users,doc.data()])
  //     let record = doc.data();
  //     record.id = doc.id;
  //     records.push(record);
  //     setUsers(records);
  // })

  // console.log(records)

  // })

  // // Query unpaid users
  // const querySnapshot2 = await getDocs(listaBecarios);

  // const recordsUnpaid = [];

  // querySnapshot2.forEach((doc) => {
  //   // doc.data() is never undefined for query doc snapshots
  //   // console.log(doc.id, " => ", doc.data());
  //   // setUsers([...users,doc.data()])
  //   let record = doc.data();
  //   record.id = doc.id;
  //   recordsUnpaid.push(record);

  // })
  // // setLoading(false)
  // setBecarios(recordsUnpaid)

  // }

  // Add becario
  async function handleAddBecario(e, email) {
    e.preventDefault()

    addBecarioRole({ email: email }).then((result) => {
      // console.log('add becario',result)
      result.data.message !== undefined
        ? alert(result.data.message)
        : alert("Usuario no reconocido")
    })

    getUID({ email: email }).then((response) => {
      updateBecario(response.data.uid, true)
    })
  }

  // Remove becario
  async function handleRemoveBecario(e, email) {
    e.preventDefault()

    removeBecarioRole({ email: email }).then((result) => {
      // console.log('remove becario',result)
      result.data.message !== undefined
        ? alert(result.data.message)
        : alert("Usuario no reconocido")
      // const uid = result.data.uid
      // console.log(result)
    })

    getUID({ email: email }).then((response) => {
      updateBecario(response.data.uid, false)
    })
  }

  // function deleteAllBecarios(e) {
  //   e.preventDefault()

  //   becarios.forEach((docSnapshot) => {
  //     const docRef = doc(db, "users", docSnapshot.uid)
  //     // console.log(docRef)
  //     // console.log(`Retrieved document with ID ${docSnapshot.uid} successfully.`);

  //     // deleteDoc(docRef)
  //     //   .then(() => {
  //     //     console.log(`User with ID ${docSnapshot.uid} deleted successfully.`)
  //     //   })
  //     //   .catch((error) => {
  //     //     console.error(
  //     //       `Error deleting user with ID ${docSnapshot.uid}:`,
  //     //       error
  //     //     )
  //     //   })
  //   })
  // }

  // ==============================================
  // HTML
  // ==============================================

  return (
    <>
      <Navigation />
      <Container
        className='align-items-center justify-content-center mt-4'
        style={{ maxWidth: "600px" }}
      >
        <h2 className='mb-4'>Lista de Becarios</h2>

        {/* Uncomments for MAKE ADMIN  */}

        {currentAdmin && (
          <div className='d-flex justify-content-around'>
            <Form className='m-2 w-75'>
              <Form.Group id='admin-email'>
                <Form.Label>Email</Form.Label>
                <Form.Control type='email' ref={emailRef} required />
              </Form.Group>

              <div className='d-flex justify-content-between'>
                <Button
                  className='w-200 mt-2'
                  disabled={loading}
                  variant='success'
                  onClick={(e) => handleAddBecario(e, emailRef.current.value)}
                >
                  Asignar becario
                </Button>
                <Button
                  className='w-200 mt-2'
                  disabled={loading}
                  variant='danger'
                  onClick={(e) =>
                    handleRemoveBecario(e, emailRef.current.value)
                  }
                >
                  Quitar becario
                </Button>
              </div>

              {/* <Button
              className='w-200 mt-2'
              disabled={loading}
              variant='danger'
              onClick={(e) => deleteAllBecarios(e)}
            >
              Quitar todos los becarios
            </Button> */}
            </Form>
          </div>
        )}
      </Container>
      <div className='container'>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th scope='col' width={"25%"}>
                Nombre
              </th>
              <th scope='col' width={"25%"}>
                Apellido
              </th>
              <th scope='col' width={"20%"}>
                Email
              </th>
              <th scope='col' width={"20%"}>
                Payment Type
              </th>
            </tr>
          </thead>
          <tbody>
            {becarios &&
              becarios
                // .filter((becarios) => {
                //   return becarios.becario === true;
                // })
                .map((arrayData, index) => {
                  return (
                    <tr key={arrayData.uid}>
                      <td>{arrayData.Name}</td>
                      <td>{arrayData.Surname}</td>
                      <td>{arrayData.email}</td>
                      <td>{arrayData.PaymentType}</td>
                    </tr>
                  )
                })}
          </tbody>
        </table>
      </div>
    </>
  )
}
